/* eslint-disable no-console */
import addProducts from './modules/product-registration/add-product-new';
import completeRegistration from './modules/product-registration/complete-registration';
import registrationInfo from './modules/product-registration/registration-info';

// console.log('\n\n\n****************************\n\nproduct-registration.min.js ver: 1.2.2\n\n****************************\n\n\n');
if (document.querySelector('.pr-form') !== null) {
  registrationInfo();
}
if (document.querySelector('.pr-add-products-form') !== null) {
  addProducts();
}
if (document.querySelector('.pr-complete-registration-form') !== null) {
  completeRegistration();
}
/* eslint-enable no-console */
